<template>
<div class="input-group">
  <input v-validate="validation" class="input-field" :data-vv-as="label" :class="{dirty: value.length > 0}" :type="type" :value="value" :name="name" @input="$emit('updateValue', $event.target.value)">
  <span class="input-highlight"></span>
  <span class="input-bar"></span>
  <label class="input-label">{{label}} <span class="error"> - {{errors.first(name)}}</span></label>
</div>
</template>

<script>
const inputTypes = ['text', 'tel', 'number', 'email', 'password', 'date', 'file', 'hidden']

export default {
  name: 'popup-input',
  inject: ['$validator'],
  props: {
    materialIcon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text',
      validator: function(value) {
        return inputTypes.indexOf(value) > -1
      }
    },
    value: {
      required: true
    },
    name: {
      required: true
    },
    validation: {
      default: ''
    }
  },
  model: {
    prop: 'value',
    event: 'updateValue'
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/config.scss';

.error {
  color: red;
}

.input-group {
  position: relative;
  width: 100%;
  margin-bottom: 16px;
  margin-top: 8px;
  text-align: left;
  background-color: #f6f6f6;
  border-radius: 16px;
  padding: 16px;
  height: 80px;
  line-height: 1.5;
  box-shadow: 6px 8px 12px rgba(0, 0, 0, 0.1);
  filter: progid:DXImageTransform.Microsoft.dropshadow(OffX=10, OffY=10, Color='#000000');

  &:last-of-type {
    margin-bottom: 0px;
  }

  .input-field {
    color: #3e3d40;
    font-size: 16px;
    padding: 16px 0px 0px 0px;
    display: block;
    width: 100%;
    border: none;
    border-bottom: 1px solid #dee2e5;
    background: transparent;

    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;

    box-shadow: 0 0 0 30px #f6f6f6 inset;
    -webkit-box-shadow: 0 0 0 30px #f6f6f6 inset;
  }
  .input-field:focus {
    outline: none;
  }

  /* .input-LABEL ======================================= */
  .input-label {
    color: #888888;
    font-size: 15px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    top: 30px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;

    user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -o-user-select: none;

    .error {
      font-size: inherit;
      font-weight: inherit;
      opacity: 0;
      transform: translateX(-8px);
      display: inline-block;
    }
  }

  /* active state */
  .input-field:focus ~ .input-label,
  .input-field.dirty ~ .input-label {
    top: 16px;
    font-size: 13px;
    color: $primaryColor;
  }
  .input-field:focus,
  .input-field.dirty {
    padding-top: 22px;
  }
  .input-field.invalid.touched ~ .input-label,
  .input-field.wrong ~ .input-label {
    color: $errorColor !important;
  }
  .input-field.wrong:focus ~ .input-label,
  .input-field.invalid.dirty ~ .input-label {
    .error {
      // display: inline;
      opacity: 1;
      transform: translateX(0px);
      transition-property: opacity, transform;
      transition-delay: 0.2s;
      transition-duration: 0.2s;
      transition-timing-function: ease;
    }
  }
  /* BOTTOM BARS ================================= */
  .input-bar {
    position: relative;
    display: block;
    width: 100%;
  }
  .input-field.invalid.touched ~ .input-bar:before,
  .input-field.invalid.touched ~ .input-bar:after {
    width: 50%;
    background: $errorColor;
  }
  .input-bar:before,
  .input-bar:after {
    content: '';
    height: 1px;
    width: 0;
    bottom: 1px;
    position: absolute;
    background: $primaryColor;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
  }
  .input-bar:before {
    left: 50%;
  }
  .input-bar:after {
    right: 50%;
  }
  .input-field:focus ~ .input-bar:before,
  .input-field:focus ~ .input-bar:after {
    width: 50%;
  }

  /* HIGHLIGHTER ================================== */
  .highlight {
    position: absolute;
    height: 60%;
    width: 100px;
    top: 25%;
    left: 0;
    pointer-events: none;
    opacity: 0.5;
  }

  /* active state */
  .input-field:focus ~ .highlight {
    -webkit-animation: inputHighlighter 0.3s ease;
    -moz-animation: inputHighlighter 0.3s ease;
    animation: inputHighlighter 0.3s ease;
  }

  .input-field.invalid.touched ~ .highlight {
    -webkit-animation: inputHighlighterDanger 0.3s ease;
    -moz-animation: inputHighlighterDanger 0.3s ease;
    animation: inputHighlighterDanger 0.3s ease;
  }
}

@-webkit-keyframes inputHighlighter {
  from {
    background: $primaryColor;
  }
  to {
    width: 0;
    background: transparent;
  }
}

@-moz-keyframes inputHighlighter {
  from {
    background: $primaryColor;
  }
  to {
    width: 0;
    background: transparent;
  }
}

@keyframes inputHighlighter {
  from {
    background: $primaryColor;
  }
  to {
    width: 0;
    background: transparent;
  }
}

@-webkit-keyframes inputHighlighterDanger {
  from {
    background: $errorColor;
  }
  to {
    width: 0;
    background: transparent;
  }
}

@-moz-keyframes inputHighlighterDanger {
  from {
    background: $errorColor;
  }
  to {
    width: 0;
    background: transparent;
  }
}

@keyframes inputHighlighterDanger {
  from {
    background: $errorColor;
  }
  to {
    width: 0;
    background: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/inputs/PopupInput.vue